/**
 * SliderArrowsContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled slider arrow container.
 */
const SliderArrowsContainer = styled.div<React.CSSProperties>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 150;
`;

export default withOpacity(SliderArrowsContainer);
